import { CreatorIntegrationsApiClient } from '@fourthwall/services/dist/CreatorIntegrationsApiClient'
import { createMutationHook } from '@fourthwall/utils/dist/queries'

export const useDeleteTiktokShopConfigurationMutation = createMutationHook(
  CreatorIntegrationsApiClient.deleteTiktokPartnerConfiguration,
  {
    mutationKey: ['deleteTiktokShopConfiguration'],
    onError: undefined,
  },
)
